import * as yup from 'yup'

export const societyWebsiteImagesUploadSchema = yup
  .object({
    mainPictureId: yup.array(yup.string()),
    societyPictureIds: yup.array(yup.string()),
    show: yup.boolean(),
  })
  .required()
